const integrations = {
	title: "Integrations",
	stitle: "Integration",
	new_integration: "New Integration",
	edit_integration: "Edit Integration: {name}",
	list_title: "List of Integrations",
	id: "ID",
	tenant_id: "Tenant",
	name: "Name",
	slug: "Tag",
	key: "Key / Username",
	secret: "Secret / Password",
	status: "Status",
	add_integration: "Add Integration",
	update_integration: "Update Integration",
	p360: "P360",
	p360_confirm: "Course certificate will be exported to Public360. This action is irreversible. Do you want to proceed? ",
	p360_invalid_pid: "Student {name} does not have PID stored in db. Upload to P360 is not possible.",
	p360_upload_failed: "Upload to P360 has failed. Please try again later. If error persits please contact administrator.",
	p360_upload_success: "File successfully uploaded.",
	p360_upload_failed_date: "Last upload on {date} has failed",
};
export default integrations;